/**
 * Horizontal metrics that keep the panel and the list underneath it on one column.
 *
 * `afas-chat-overview` applies its own insets inside its shadow root and exposes them
 * through neither CSS custom properties nor parts, so the only way to line up with them is
 * to mirror them — or, where they disagree with the design, to override them from a
 * stylesheet injected into that root (see `applyOverviewOverrides` in the panel). The
 * values below were measured in the browser against the package version pinned in
 * `app/package.json`; a bump needs a re-measure, which the accompanying test enforces by
 * failing when that pin moves.
 */

/** The version these numbers were measured against. */
export const MEASURED_AGAINST_VERSION = "2.1.23";

/**
 * Vertical step below the header, before the list starts. The body itself carries no
 * padding — the overview's scroll box has to reach the divider so its scrollbar sits
 * against it — so this space belongs to the header, and the rail repeats it.
 */
export const PANEL_STACK_GAP = 8;

/** Inset of the "new chat" button and the search field within the overview. */
export const OVERVIEW_CONTROL_INSET = 12;

/**
 * The one column every label in the workspace starts at: the appbar wordmark, the panel
 * header, the "new chat" button, the group labels and the conversation titles. It is the
 * overview's own control inset, so the button — the widest thing that would have to move —
 * stays put and everything else is pulled onto it.
 */
export const PANEL_TEXT_INSET = OVERVIEW_CONTROL_INSET;

/** Puts the header title on the same line as "Ouder" and the conversation titles. */
export const HEADER_PADDING_START = PANEL_TEXT_INSET;

/** Ends the collapse button's hover box where the "new chat" button ends. */
export const HEADER_PADDING_END = OVERVIEW_CONTROL_INSET;
